var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.config_name"),
                  placeholderValue: _vm.$t("common.routing.config_name"),
                },
                model: {
                  value: _vm.name,
                  callback: function ($$v) {
                    _vm.name = $$v
                  },
                  expression: "name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
            _c("label", { attrs: { for: "active" } }, [
              _vm._v("\n          " + _vm._s(_vm.$t("common.routing.active"))),
              _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.active,
                    expression: "active",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  disabled: _vm.readonly,
                  id: "active",
                  "aria-label": _vm.$t("common.routing.active"),
                },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.active = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { value: "1" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("common.routing.yes")) + " "),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "2", selected: "" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("common.routing.no")) + " "),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.host"),
                  placeholderValue: _vm.$t("common.routing.host"),
                },
                model: {
                  value: _vm.host,
                  callback: function ($$v) {
                    _vm.host = $$v
                  },
                  expression: "host",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.port"),
                  placeholderValue: _vm.$t("common.routing.port"),
                },
                model: {
                  value: _vm.port,
                  callback: function ($$v) {
                    _vm.port = $$v
                  },
                  expression: "port",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.formatName != "" && _vm.formatOutName != ""
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: "",
                      inputLabel: _vm.$t("common.routing.format_name"),
                      placeholderValue: _vm.$t("common.routing.format_name"),
                    },
                    model: {
                      value: _vm.formatName,
                      callback: function ($$v) {
                        _vm.formatName = $$v
                      },
                      expression: "formatName",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formatName != "" && _vm.formatOutName != ""
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: "",
                      inputLabel: _vm.$t("common.routing.format_out_name"),
                      placeholderValue: _vm.$t(
                        "common.routing.format_out_name"
                      ),
                    },
                    model: {
                      value: _vm.formatOutName,
                      callback: function ($$v) {
                        _vm.formatOutName = $$v
                      },
                      expression: "formatOutName",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.login"),
                  placeholderValue: _vm.$t("common.routing.login"),
                },
                model: {
                  value: _vm.login,
                  callback: function ($$v) {
                    _vm.login = $$v
                  },
                  expression: "login",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.password"),
                  placeholderValue: _vm.$t("common.routing.password"),
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v
                  },
                  expression: "password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.peer_name"),
                  placeholderValue: _vm.$t("common.routing.peer_name"),
                },
                model: {
                  value: _vm.peerName,
                  callback: function ($$v) {
                    _vm.peerName = $$v
                  },
                  expression: "peerName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.timeout"),
                  placeholderValue: _vm.$t("common.routing.timeout"),
                },
                model: {
                  value: _vm.timeout,
                  callback: function ($$v) {
                    _vm.timeout = $$v
                  },
                  expression: "timeout",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.queue_manager"),
                  placeholderValue: _vm.$t("common.routing.queue_manager"),
                },
                model: {
                  value: _vm.queueManager,
                  callback: function ($$v) {
                    _vm.queueManager = $$v
                  },
                  expression: "queueManager",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.channel_name"),
                  placeholderValue: _vm.$t("common.routing.channel_name"),
                },
                model: {
                  value: _vm.channelName,
                  callback: function ($$v) {
                    _vm.channelName = $$v
                  },
                  expression: "channelName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.queue_name"),
                  placeholderValue: _vm.$t("common.routing.queue_name"),
                },
                model: {
                  value: _vm.queueName,
                  callback: function ($$v) {
                    _vm.queueName = $$v
                  },
                  expression: "queueName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
            _c("label", { attrs: { for: "ssl-active" } }, [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("common.routing.ssl_active"))
              ),
              _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.sslActive,
                    expression: "sslActive",
                  },
                ],
                staticClass: "form-control",
                attrs: { disabled: _vm.readonly, id: "ssl-active" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.sslActive = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { value: "1" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("common.routing.yes")) + " "),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "0" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("common.routing.no")) + " "),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.sslActive == 1
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t("common.routing.file_kdb"),
                      placeholderValue: _vm.$t("common.routing.file_sth"),
                    },
                    model: {
                      value: _vm.kdb,
                      callback: function ($$v) {
                        _vm.kdb = $$v
                      },
                      expression: "kdb",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sslActive == 1
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t("common.routing.file_sth"),
                      placeholderValue: _vm.$t("common.routing.file_sth"),
                    },
                    model: {
                      value: _vm.sth,
                      callback: function ($$v) {
                        _vm.sth = $$v
                      },
                      expression: "sth",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.sslActive === "1"
        ? _c("level-control-form", {
            attrs: {
              mode: _vm.mode,
              readonly: _vm.readonly,
              placementLevel: _vm.placementMQSeries,
            },
            model: {
              value: _vm.controlConfig,
              callback: function ($$v) {
                _vm.controlConfig = $$v
              },
              expression: "controlConfig",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.entitiesType === "rvm"
        ? _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.vop_provider.vop_provider"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", { attrs: { for: "vopProvider" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.vop_provider.name"))
                        ),
                        _c("span", { staticClass: "color-red" }, [
                          _vm._v(" * "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.IdVopProvider,
                              expression: "IdVopProvider",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { disabled: _vm.readonly, id: "vopProvider" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.IdVopProvider = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "", hidden: "", disabled: "" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "common.routing.select_name_vop_provider"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.vopProviderList, function (vopProvider) {
                            return _c(
                              "option",
                              {
                                key: vopProvider.id,
                                domProps: { value: vopProvider.id },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(vopProvider.text) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }